import React from 'react';
import { useHistory } from "react-router-dom";
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import { COLOR } from 'constants/colors';
import styled from 'styled-components';
import useFlashToggler from 'hooks/use-flash-toggler';
import { useSelector, useDispatch } from 'react-redux';
import { ENDPOINTS } from 'constants/endpoints';
import { propsToJS } from '__utils/immutable-to-js';
import ProfileViewSelector from '../../profile-view.selector';
import panDetailsSelector from '../kyc-details.selector';
import { getDefaultHeaders, post, } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { getEncryptedUserId, getPrimaryEmail, getPrimaryMobile, isMintproApp, logOutUser, isProUser, isBtoCFlow } from '__utils/common-utils';
import resolveURLParams from '__utils/url-params-resolver';
import exclamation from "images/exclamation.svg";
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import phone from 'images/phone.svg';
import kycWarning from "images/kycWarning.svg";
import './index.css';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails, setKycInCookie } from '__utils/storage';
import { SET_NAME_IN_HEADER } from 'constants/actions';
import disclaimerOrgIcon from "images/disclaimerOrgIcon.svg";

const PanSubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
        margin-top: 1rem; 
        width: ${(props: any) => props.specificWidth ? props.specificWidth : "173px"};
        font-size: 14px; 
`;
const SuccessBtnWhite = styled(SuccessButtonWhiteBg) <CommonStyledComponentProps>`
    width: 100px;
    font-size: 14px; 
    border: 1px solid ${COLOR.GREEN};
    &:hover,
    &:focus,
    &:active {
        background-color: transparent;
        border-color: ${COLOR.GREEN};
        color: ${COLOR.GREEN};
    }
`;

interface PanProps {
    pan: string;
    clearPan: (setClear: boolean) => void;
}
const KycStatusMessage: React.FC<PanProps> = (props: PanProps) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { profileView, nameInHeader } = propsToJS(useSelector(ProfileViewSelector));
    const { kycDetails } = propsToJS(useSelector(panDetailsSelector));
    const flash = useFlashToggler();
    const logoutDuplicatePan = () => {
        logOutUser();
    }

    const kycDeclaration = ( ) => <p className='kycDeclarationMsg'>**I/we understand that the details furnished in this form (like PAN, Date of Birth, Aadhaar etc) would be utilized by the Distributor to fetch my/our KYC details from central databases like CVL KRA and CKYC database or other database. We hereby provide our consent for fetching of such information.</p>;
    const filterKycName = (name?: any) => {
        var regex = /(Mr|Ms|Miss|Mrs|Dr|Sir|Master|Rev|Prof|Retd)(\.?)\s/i;
        let match = regex.exec(name);
        let newName = "";
        newName = (match !== null) ? name.replace(match[ 0 ], "") : name;
        return (newName.replace(/[^a-zA-Z ]/g,"").trim());
    }
    const isKycCompliant = (kycDetails: any) => {
        if (kycDetails?.status === "KYC_REGISTERED_STATUS" || kycDetails?.status === "KYC_UNDER_PROCESS_STATUS" || kycDetails?.status === "KYC_UNDER_PROCESS_STATUS_SHORT")
        {
            return true;
        }
    }
    const isKycNonCompliant = (kycDetails: any) => {
        if ((kycDetails?.status === "KYC_NON_COMPLIANT_STATUS" || kycDetails?.status === "KYC_NOT_AVAILABLE"))
        {
            if (!kycDetails?.error)
                return true;
        }
    }
    const isKycOnHold= (kycDetails: any) => {
        if (kycDetails?.status === "KYC_HOLD_REJECTED_STATUS") return true;
    }
    const isKycValidated= (kycDetails: any) => {
        if (kycDetails?.status === "KYC_VALIDATED_STATUS") return true;
    }
    const isKycNonCompliantWithError = (kycDetails: any) => {
        if (kycDetails?.error && kycDetails?.status === "KYC_NON_COMPLIANT_STATUS")
        {
            return true;
        }
    }
    const isKycDuplicate = (kycDetails: any) => {
        if (kycDetails?.status === "KYC_DUPLICATE_PAN_STATUS")
        {
            return true;
        }
    }
    const isKycPanNotMatch = (kycDetails: any) => {
        if (kycDetails?.status === "KYC_PAN_DOES_NOT_MATCH_STATUS") {
            return true;
        }
    }
    const redirectToSignzy = () => {
        if(profileView?.registeredWithBse !== 3){
            Mixpanel.track(getEventName("doKyc", "clicked", "checkout"), {
                agentCode: getAgentCode(),
                user: getUserDetails(),
                isBtoCFlow: isBtoCFlow(),
            });
            const data = {
                "pancard": props?.pan,
                "email": getPrimaryEmail(),
                "name": nameInHeader,
                "callbackUrl": window.location.protocol + "//" + window.location.host + '/v1/signzy-callback',
                "mobile": getPrimaryMobile(),
                "device": isMobile ? "mobile" : null
            };
            dispatch({
                type: SET_NAME_IN_HEADER,
                payload: filterKycName(kycDetails?.kycName)
            });
            const profileData = { ...profileView, ...{ pan: props?.pan, name: filterKycName(kycDetails?.kycName), panStatus: kycDetails?.rawStatus, primaryEmail: getPrimaryEmail() } }
            setKycInCookie({ ...kycDetails, pan: props?.pan });
            post(resolveURLParams(ENDPOINTS.POST_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), profileData, getDefaultHeaders(), true)
                .subscribe((response: AjaxResponse | AjaxError) => {
                    post(resolveURLParams(ENDPOINTS.GET_REDIRECT_KYC, {}, {}), data, getDefaultHeaders(), true)
                        .subscribe((response: AjaxResponse | AjaxError) => {
                            if (isMintproApp())
                            {
                                var featurePayload = {
                                    type: 'chromeTab',
                                    payload: {
                                        url: response?.response?.url
                                    },
                                };
                                window.postMessage(JSON.stringify(featurePayload), '*');
                            }
                            else
                                window.open(response?.response?.url, '_blank')?.focus();
                        }, (error: AjaxError) => {
                            flash.error("Unable to redirect. Please try again later.")
                        });
                }, (error: AjaxError) => {
                    flash.error("Can not update. Please try later.")
                });
        }
   

    }
    const savePanDetails = (profileView: any) => {
        Mixpanel.track(getEventName("createAccount", "clicked", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        if(profileView?.registeredWithBse === 3){
            history.push('/profile/personal-details');
        }
        else{
            const profileData = { ...profileView, ...{ pan: props?.pan, name: filterKycName(kycDetails?.kycName), panStatus: kycDetails?.rawStatus, primaryEmail: getPrimaryEmail() } };
            setKycInCookie({ ...kycDetails, pan: props?.pan });
            dispatch({
                type: SET_NAME_IN_HEADER,
                payload: filterKycName(kycDetails?.kycName)
            });
            profileData && post(resolveURLParams(ENDPOINTS.POST_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), profileData, getDefaultHeaders(), true)
                .subscribe((response: AjaxResponse | AjaxError) => {
                    history.push('/profile/personal-details');
    
                }, (error: AjaxError) => {
                    flash.error("Can not update. Please try later.")
                });
        }
       
    }
    
    return (

        <div>
            {
               ( isKycCompliant(kycDetails) || isKycValidated(kycDetails)) &&
                <div className="kyc-message">
                    { isMobile && <hr /> }
                    <p>
                        <i className="icon-round-check"></i>
                        This PAN number is registered with { filterKycName(kycDetails?.kycName) } & we will be creating your investment account with the same name.
                        <br /><br />
						{kycDetails?.status === 'KYC_REGISTERED_STATUS' ? <ol style={{ padding: '15px', fontSize: '14px' }}>
                            <li>You can continue making transactions (like Purchases, Redemptions, Switches, SIPs, etc.) in all your existing Mutual Fund investments without any hassle.</li>
                            <li>Only if you want to invest in a mutual fund where you don’t have any investment already, you will have to do your KYC once again.</li>
                            <li>You can get your KYC status changed to ‘KYC Validated’ by doing the KYC Update/ KYC Modification process using PAN and Aadhaar from XML, Digi-locker or M-Aadhaar. </li>
                            <li>Once your KYC status changes to Validated you can invest in any Mutual Fund of your choice without any requirement of re-KYC.</li>
                        </ol> :isKycValidated(kycDetails) ? <p>Since the KYC is Validated you can invest in any Mutual Fund Scheme</p>: <p>Your KYC is under process, kindly keep a track of the final status of your KYC to avoid any future rejections.</p>}
                        <br/>
                        To create your investment account you will need to have the following documents handy:
                    </p>
                    <ol style={ { padding: "15px", fontSize: "14px" } }>
                        <li>Adhaar Card</li>
                        <li>Image of Bank Cancelled Cheque</li>
                        <li>Image of your signature on white paper.</li>
                    </ol>
                    {kycDeclaration()} <br/>
                    <PanSubmitButton isMobile={ isMobile }
                        onClick={ () => { savePanDetails(profileView) } }>{ (profileView?.pan) ? "Continue" : "Create My Account" }</PanSubmitButton>
                </div>
            }
            {
                isKycNonCompliant(kycDetails) &&
                <div className="kyc-message">
                    { isMobile && <hr /> }
                    <p>
                        <i className="icon-round-cross"></i>
                        <span>Your PAN number is not KYC compliant.</span>
                        <br /><br />
                        { filterKycName(kycDetails?.kycName) && <span>This PAN number is registered with { filterKycName(kycDetails.kycName)} & we will be creating your investment account with the same name.<br /><br /></span> }
                        You can get your KYC done in 10 mins if you have following things handy with you.
                    </p>
                    <ol className='kyc-message-list'>
                        <li>Identity proof - PAN Card.</li>
                        <li>Address proof - Adhaar card (with OTP - Digilocker)/Driving License/Voter ID/Passport.</li>
                        <li>Signed cancelled cheque of your bank account.</li>
                        <li>Image of your signature on plain paper.</li>
                        <li>Mobile phone which is linked to your Adhaar account for OTP.</li>
                    </ol>
                    <p className='kycVideoDisclaimer'><img src={disclaimerOrgIcon} alt="disclaimer for kyc" /> Video KYC mandatory if you choose Driving License / Voter ID/ Passport as your address proof</p>
                    {kycDeclaration()} <br/>
                    <PanSubmitButton isMobile={ isMobile } onClick={ () => { redirectToSignzy() } } >Do KYC Process</PanSubmitButton>
                </div>
            }
            {
                isKycOnHold(kycDetails) &&
                <div className="kyc-message">
                    { isMobile && <hr /> }
                    <p>
                        <i className="icon-round-cross"></i>
                        <span>Your KYC is on Hold- You would need to do a physical KYC in order to proceed with the investments. This  could be due to: Mobile or Email not validated / PAN is not linked with Aadhaar / Deficiency in the KYC documents, etc.Once your KYC status changes to Registered/Validated you will be all set to start transacting, as per the KYC status. (ICICI Signzy link in this case shouldn't be visible to the user as for KYC which are on Hold only physical KYC can be done)</span>
                        <br /><br />  
                    </p>
                    <div style={ { margin: !isMobile ? "0" : "5px 0 0 18px" } }>
                        <img src={ phone } alt="call expert" />&nbsp;
                        <span className="call-text" ><a href="tel:18002666468" className="call-text"
                            onClick={ () => {
                                Mixpanel.track(getEventName("callExpert", "clicked", "header"), {
                                    agentCode: getAgentCode(),
                                    user: getUserDetails(),
                                    isBtoCFlow: isBtoCFlow(),
                                })
                        } }>Call Customer Care</a></span>
                    </div>
                </div>
            }
            {
                isKycNonCompliantWithError(kycDetails) &&
                <div className="kyc-message">
                    { isMobile && <hr /> }
                    <p>
                        <i className="icon-round-cross"></i>
                        <span>{ kycDetails?.error }</span>
                    </p> <br /><br />
                    { isProUser() ?
                        <div style={ { display: !isMobile ? "flex" : "block" } }>
                            <PanSubmitButton isMobile={ isMobile } specificWidth="210px" onClick={ () => { props.clearPan(true) } } >Clear</PanSubmitButton>&nbsp;&nbsp;
                            <div style={ { margin: !isMobile ? "25px 0 0 10px" : "15px 0 0 18px" } }>
                                <img src={ phone } alt="call expert" />&nbsp;
                                <span className="call-text" ><a href="tel:18002666468" className="call-text"
                                    onClick={ () => {
                                        Mixpanel.track(getEventName("callExpert", "clicked", "header"), {
                                            agentCode: getAgentCode(),
                                            user: getUserDetails(),
                                            isBtoCFlow: isBtoCFlow(),
                                        })
                                    } }>Call Customer Care</a></span>
                            </div>
                        </div> :
                        <div>
                            <div className={ isMobile ? "btn-align jcc" : "btn-align" }>
                                <PanSubmitButton isMobile={ isMobile } specificWidth="210px" onClick={ () => {
                                    Mixpanel.track(getEventName("loginWithAnotherNumber", "clicked", "checkout"), {
                                        agentCode: getAgentCode(),
                                        user: getUserDetails(),
                                        isBtoCFlow: isBtoCFlow(),
                                    });
                                    logoutDuplicatePan();
                                } } >Login with another number</PanSubmitButton>&nbsp;&nbsp;
                                <SuccessBtnWhite isMobile={ isMobile } specificWidth="210px" onClick={ () => { props.clearPan(true) } } >Clear</SuccessBtnWhite>&nbsp;&nbsp;
                            </div>
                            <br />
                            <div style={ { margin: !isMobile ? "0" : "5px 0 0 18px" } }>
                                <img src={ phone } alt="call expert" />&nbsp;
                                <span className="call-text" ><a href="tel:18002666468" className="call-text"
                                    onClick={ () => {
                                        Mixpanel.track(getEventName("callExpert", "clicked", "header"), {
                                            agentCode: getAgentCode(),
                                            user: getUserDetails(),
                                            isBtoCFlow: isBtoCFlow(),
                                        })
                                    } }>Call Customer Care</a></span>
                            </div>
                        </div>
                    }
                </div>
            }
              {(isKycDuplicate(kycDetails) || isKycPanNotMatch(kycDetails)) &&
                <div className="kyc-message">
                    {isMobile && <hr />}
                    <div className={`startRowFlex kyc-warning-bg ${isMobile ? 'exclamationPaddingMobile' : 'exclamationPadding'}`}>
                        <div className={isMobile ? '' : 'exclamationAbsolute'}>
                            <img src={kycWarning} />
                        </div>

                        {isKycDuplicate(kycDetails)? <span style={{ marginLeft: isMobile ? '10px' : '110px' }}>
                                <b>This PAN card number is linked to investment account of mobile no {(kycDetails?.duplicateMobNo)?.replace(/.(?=\d{4})/g, "x")}.</b>
                                {!isMobile && <br />}Please check the PAN number or try to login with above mentioned mobile number.
                            </span> : <span style={{ marginLeft: isMobile ? '10px' : '110px' }}> <b>{kycDetails?.rawStatus}.</b>
                                {!isMobile && <br />}Please check the PAN number or try to login with another mobile number.</span>

                        }
                    </div>
                    <br />
                    <div>
                        <div className={isMobile ? "btn-align jcc" : "btn-align"}>
                            <PanSubmitButton isMobile={isMobile} specificWidth="210px" onClick={() => {
                                Mixpanel.track(getEventName("loginWithAnotherNumber", "clicked", "checkout"), {
                                    agentCode: getAgentCode(),
                                    user: getUserDetails(),
                                    isBtoCFlow: isBtoCFlow(),
                                });
                                logoutDuplicatePan();
                            }} >Login with another number</PanSubmitButton>&nbsp;&nbsp;
                            <SuccessBtnWhite isMobile={isMobile} specificWidth="210px" onClick={() => { props.clearPan(true) }} >Clear</SuccessBtnWhite>&nbsp;&nbsp;
                        </div>
                        <br />
                        <div style={{ margin: !isMobile ? "0" : "5px 0 0 18px" }}>
                            <img src={phone} alt="call expert" />&nbsp;
                            <span className="call-text" ><a href="tel:18002666468" className="call-text">Call Customer Care</a></span>
                        </div>
                    </div>

                </div>
            }
        </div>

    );
};

export default KycStatusMessage;
